import Scene, { ISceneParams } from './Scene';
import Game from '../Game';
import MyPetMiniGameSystem from '../System/MyPetMiniGame/MyPetMiniGameSystem';
import TimerSystem from '../System/Timer/TimerSystem';
import AnimationSystem from '../System/Animation/AnimationSystem';
import RenderSystem from '../System/Render/RenderSystem';
import AudioSystem from "System/Audio/AudioSystem";

export type MyPetMiniGameSceneParams = ISceneParams & {
    forceJackpotWin?: boolean;
};

export default class MyPetMiniGameScene extends Scene {
    public params: MyPetMiniGameSceneParams;

    public init(): void {
        this.addSystem(new TimerSystem(Game.store));
        this.addSystem(new MyPetMiniGameSystem({
            state: Game.store,
            forceJackpotWin: this.params.forceJackpotWin ?? false,
        }));
        this.addSystem(new AnimationSystem(Game.store));
        this.addSystem(new RenderSystem(Game.store));
        this.addSystem(new AudioSystem(Game.store));

        this.systems.forEach(system => system.init());
    }
}
